import type { Flag } from '../featureflags/flag';

export interface IService {
	flags: Flag[];
	name: string;
}

export class Service implements IService {
	public flags: Flag[];
	public name: string;
	public constructor({ flags, name }: IService) {
		this.flags = flags;
		this.name = name;
	}
}
